import { Card, Grid, Typography } from "@mui/material";
import React from "react";
import { useForm, useWatch } from "react-hook-form";
import WSButton from "../../../Components/Button/WSButton";
import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
// import background from '../../../src/images/login-bg.svg'
import { Link, useNavigate } from "react-router-dom";
import { callAPI, customValidation, handleApiError, Method, validations } from "../../../commonFunctions/CommonFunctions";
import WSAutocompleteField from "../../../Components/AutoComplete/AutoComplete";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import clientConfig from '../../../Config/clientConfig.json';
import backImg from "../../../images/login-bg.svg";
import logo from "../../../images/logo.svg";
export const Registration: React.FC<any> = React.memo(() => {
  const { register, handleSubmit, control, formState: { }, setValue, watch, reset } = useForm();
  const password = useWatch({ control, name: "password" });
  const confirmPassword = useWatch({ control, name: "confirmpassword" });
  const passwordsMatch = password === confirmPassword;
  const { showMessage } = useSnackbar();
  const navigate = useNavigate();
  const handleData = async (data: any) => {

    try {
      const request: any = await setRequest(data);
      const response: any = await callAPI('/auth/register', Method.POST, request);
      if (response?.errors) {
        const mess = handleApiError(response)
        showMessage(mess, 'error');
      }
      else if (response) {
        showMessage(response?.message, response.success === true ? "success" : "error");
        response.success === true && navigate("/login");
      }
    } catch (e: any) {
      showMessage(e.error);
    }
  };
  /**
   * Method to set the request for the user
   * @param data 
   * @returns 
   */
  async function setRequest(data: any) {
    // let encryptedPassword = undefined;
    // if (data?.password && data?.password !== '') {
    //     const secretKey = await generateKey();
    //     encryptedPassword = await encryptPassword(data?.password, secretKey);
    //     // Decrypt the password
    //     // const decryptedPassword = await decryptPassword(encryptedPassword, secretKey);
    // }
    let request: any = {
      firstName: data?.firstName,
      lastName: data?.lastName,
      email: data?.email,
      pin: data?.pin || "",
      password: data?.password,// encryptedPassword,
      roleId: data?.roleId,
    };
    return request // clearRequest(request);
  }
  return (
    <Grid sx={{ padding: 5 }} item container>
      <Grid sm={6} style={{ marginTop: -23 }}>
        <img src={logo} style={{ marginTop: -2 }} ></img>
      </Grid>

      <Grid
        container
        sx={{
          backgroundImage: `url(${backImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '85vh',
          padding: 12,
          borderRadius: 5,
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',

        }}
      >
        <Card
          sx={{
            p: 4, // Increased padding for better spacing
            borderRadius: 3,
            width: '60%',
            boxShadow: 3,
            // height:'30rem',
            display: "flex",
            marginTop: -11,
            flexDirection: "column",
            alignItems: "center", // Ensures form elements are centered inside the Card
          }}
        >
          <form onSubmit={handleSubmit(handleData)} style={{ width: "100%" }}>
            <Typography variant="h5" sx={{ fontWeight: "bold", color: "#7D79C2", }}>
              Create an Account
            </Typography>
            <Typography variant="body1" sx={{ mt: 2, color: "#7D79C2", }}>
              Welcome, please enter your details.
            </Typography>

            {/* Grid container for form fields */}
            <Grid xs={12} className="modal-input" container spacing={2} style={{ marginTop: 10 }}>
              <Grid item sm={6} xs={12}>
                <WSTextField control={control} id="firstName" {...register('firstName')} name="firstName" rules={{ required: true }} label="First Name *"></WSTextField>

              </Grid>
              <Grid item sm={6} xs={12}>
                <WSTextField control={control} id="lastName" {...register('lastName')} name="lastName" rules={{ required: false }} label="Last Name "></WSTextField>
              </Grid>

              <Grid item sm={6} xs={12}>
                <WSTextField control={control} id="email" {...register('email')} name="email" rules={customValidation(true, validations.email)} label="Email *"></WSTextField>
              </Grid>
              <Grid item sm={6} xs={12}>
                <WSTextField control={control} id="pin" {...register('pin')} rules={{ required: false }} minLength={6} maxLength={6} type={TextType.AllowOnlyNumber} name="pin" label="PIN" ></WSTextField>
              </Grid>
              <Grid item sm={6} xs={12}>
                <WSTextField control={control} id="password"  {...register("password", {
                  required: true,
                  validate: (value: any) => {
                    const password = watch("confirmPassword");
                    return value === password || "Passwords do not match";
                  },
                })} name="password" label="Password *" type={TextType.Password}></WSTextField>
              </Grid>


              <Grid item sm={6} xs={12}>
                <WSTextField control={control} id="confirmPassword" {...register("confirmPassword", {
                  required: true,
                  validate: (value: any) => {
                    const password = watch("password");
                    return value === password || "Passwords do not match";
                  },
                })} name="confirmPassword" label="Confirm Password *" type={TextType.Password}></WSTextField>
              </Grid>

              {/* <Grid item sm={6} xs={12}>
                        <WSPhone label="Phone *" rules={{ required: true }} control={control} id="phone" {...register('phone')} name="phone"></WSPhone>
                    </Grid> */}

              <Grid item sm={12} xs={12}>
                <WSAutocompleteField rules={{ required: true }} control={control} id="roleId" {...register('roleId')} name="roleId" label="Role *" options={clientConfig.userTypeConfig.staticOptionData}></WSAutocompleteField>
              </Grid>
            </Grid>
            {/* <Grid item xs={12}>
                <FormControlLabel control={<Switch defaultChecked />} label="I agree to all terms and conditions" />
              </Grid> */}
            <Grid item xs={12} mt={2}>
              <WSButton
                id="register"
                label="REGISTER"
                size="large"
                variant="contained"
                color="primary"
                sx={{
                  backgroundColor: "#7D79C2",
                  color: "white",
                  width: "100%",
                  cursor: "pointer",
                }}
                onClick={handleSubmit(handleData)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ mt: 2, color: "#7D79C2", textAlign: "center" }}>
                Have an account? <Link style={{ textDecoration: 'none' }} to={'/login'} >Log In</Link>
              </Typography>
            </Grid>
          </form>
        </Card>
      </Grid>
    </Grid>


  );
});
